import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import { IcBuilding, IcPlus, IcEdit, IcDollar, IcXCircle, IcCheckCircle, IcUniversity, IcMinus } from "../../../Icons";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import { v4 as uuidv4 } from "uuid";

const REGIMEN_OPTIONS = [
  { value: "",    label: "Reg Fiscal" },
  { value: "0",   label: "0" },
  { value: "601", label: "601 General de Ley Personas Morales" },
  { value: "603", label: "603 Personas Morales con Fines no Lucrativos" },
  { value: "605", label: "605 Sueldos y Salarios e Ingresos Asimilados al Salario" },
  { value: "608", label: "608 Demas Ingresos" },
  { value: "612", label: "612 Personas Físicas con Actividades Empresariales y Profesionales" },
  { value: "616", label: "616 Sin Obligacion Fiscal" },
  { value: "621", label: "621 Incorporacion Fiscal" },
  { value: "624", label: "624 Régimen de los Coordinados" },
  { value: "625", label: "625 Reg. de las act. emp. cpn ingresos a traves de plat. tec." },
  { value: "626", label: "626 Regimen simplificado de Confianza" },
];

function ListadoEmpresas() {
  const { user } = useContext(AuthContext);
  const URL_EMPRESAS        = process.env.REACT_APP_URL_EMPRESAS;
  const URL_LOGS            = process.env.REACT_APP_URL_LOGS;
  const URL_CUENTAS_EMPRESAS = process.env.REACT_APP_URL_CUENTAS_EMPRESAS;

  const [empresas, setEmpresas] = useState([]);

  // ── Edit modal ────────────────────────────────────────────────────────────
  const [modal,  setModal]  = useState(false);
  const toggle              = () => setModal(!modal);
  const [idEdit,          setIdEdit]          = useState("");
  const [name,            setName]            = useState("");
  const [prefijo,         setPrefijo]         = useState("");
  const [razonSocial,     setRazonSocial]     = useState("");
  const [rfc,             setRfc]             = useState("");
  const [cp,              setCP]              = useState("");
  const [regimenFiscal,   setRegimenFiscal]   = useState("");
  const [direccionFiscal, setDireccionFiscal] = useState("");

  // ── Create modal ──────────────────────────────────────────────────────────
  const [modalCreate,  setModalCreate]  = useState(false);
  const toggleCreate                    = () => setModalCreate(!modalCreate);
  const [cName,            setCName]            = useState("");
  const [cPrefijo,         setCPrefijo]         = useState("");
  const [cRazonSocial,     setCRazonSocial]     = useState("");
  const [cRfc,             setCRfc]             = useState("");
  const [cCp,              setCCp]              = useState("");
  const [cRegimenFiscal,   setCRegimenFiscal]   = useState("");
  const [cDireccionFiscal, setCDireccionFiscal] = useState("");
  const [validaBoton,      setValidaBoton]      = useState(true);

  // ── Cuentas modal ─────────────────────────────────────────────────────────
  const [modalCuenta,       setModalCuenta]       = useState(false);
  const toggleCuenta                              = () => setModalCuenta(!modalCuenta);
  const [cuentas,           setCuentas]           = useState([]);
  const [idEmpresaCuenta,   setIdEmpresaCuenta]   = useState("");
  const [razonSocialCuenta, setRazonSocialCuenta] = useState("");
  const [inputFieldsCuentas, setInputFieldsCuentas] = useState([
    { id: uuidv4(), banco: "", cuenta: "", rfc: "" },
  ]);

  useEffect(() => {
    axios
      .get(URL_EMPRESAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setEmpresas(response.data))
      .catch(() => {});
  }, []);

  // ── Create ────────────────────────────────────────────────────────────────
  function saveEmpresas(event) {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(URL_EMPRESAS, {
        name: cName, prefijo: cPrefijo, razonSocial: cRazonSocial,
        rfc: cRfc, cp: cCp, regimenFiscal: cRegimenFiscal, direccionFiscal: cDireccionFiscal,
      }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Crear Empresa", detalle: cName, user: user.id }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        setCName(""); setCPrefijo(""); setCRazonSocial(""); setCRfc("");
        setCCp(""); setCRegimenFiscal(""); setCDireccionFiscal("");
        setValidaBoton(true);
        toggleCreate();
        Swal.fire("¡Listo!", "Empresa creada con éxito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response?.data}` });
        setValidaBoton(true);
      });
  }

  // ── Edit ──────────────────────────────────────────────────────────────────
  function editEmpresa(event) {
    event.preventDefault();
    axios
      .patch(`${URL_EMPRESAS}/${idEdit}`, {
        name, prefijo, razonSocial, rfc, cp, regimenFiscal, direccionFiscal,
      }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Editar Empresa", detalle: name, user: user.id }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        toggle();
        Swal.fire("¡Listo!", "Actualizado con éxito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response?.data}` });
      });
  }

  function jalaInfo(idEdit, name, prefijo, razonSocial, rfc, cp, regimenFiscal, direccionFiscal) {
    setName(name); setPrefijo(prefijo); setRazonSocial(razonSocial);
    setRfc(rfc); setCP(cp); setRegimenFiscal(regimenFiscal);
    setDireccionFiscal(direccionFiscal); setIdEdit(idEdit);
    toggle();
  }

  // ── Cuentas ───────────────────────────────────────────────────────────────
  function cue(id, razonSocial) {
    setIdEmpresaCuenta(id);
    setRazonSocialCuenta(razonSocial);
    axios
      .get(`${URL_CUENTAS_EMPRESAS}/empresa/${id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setCuentas(res.data))
      .catch(() => {});
    setInputFieldsCuentas([{ id: uuidv4(), banco: "", cuenta: "", rfc: "" }]);
    toggleCuenta();
  }

  const handleChangeInputCuentasExistentes = (id, event) => {
    setCuentas(cuentas.map((i) => {
      if (id === i._id) i[event.target.name] = event.target.value;
      return i;
    }));
  };

  const handleChangeInputCuentas = (id, event) => {
    setInputFieldsCuentas(inputFieldsCuentas.map((i) => {
      if (id === i.id) i[event.target.name] = event.target.value;
      return i;
    }));
  };

  function saveCuenta() {
    let totalCuen = cuentas.length + inputFieldsCuentas.length;
    const done = () => {
      totalCuen -= 1;
      if (totalCuen === 0) {
        axios.post(URL_LOGS, { tipo: "Editar Cuentas", detalle: `Empresa ${idEmpresaCuenta}`, user: user.id }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        Swal.fire("¡Listo!", "Cuentas actualizadas", "success");
        setTimeout(() => window.location.reload(), 1000);
      }
    };
    cuentas.map((a) => {
      if (a.cuenta !== "") {
        axios.patch(`${URL_CUENTAS_EMPRESAS}/${a._id}`, { cuenta: a.cuenta, banco: a.banco, rfc: a.rfc }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        }).then(done).catch((error) => {
          Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response?.data}` });
        });
      } else { done(); }
    });
    inputFieldsCuentas.map((a) => {
      if (a.cuenta !== "") {
        axios.post(URL_CUENTAS_EMPRESAS, { empresas: idEmpresaCuenta, cuenta: a.cuenta, banco: a.banco, rfc: a.rfc }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        }).then(done).catch((error) => {
          Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response?.data}` });
        });
      } else { done(); }
    });
  }

  const handleAddFieldsCuentas    = () => setInputFieldsCuentas([...inputFieldsCuentas, { id: uuidv4(), banco: "", cuenta: "", rfc: "" }]);
  const handleRemoveFieldsCuentas = (id) => setInputFieldsCuentas(inputFieldsCuentas.filter((i) => i.id !== id));

  function altaCuenta(id) {
    axios.patch(`${URL_CUENTAS_EMPRESAS}/${id}`, { is_active: "Si" }, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    }).then(() => {
      Swal.fire("¡Listo!", "Cuenta activada", "success");
      setCuentas(cuentas.map((i) => { if (id === i._id) i.is_active = "Si"; return i; }));
    }).catch(() => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" }));
  }

  function bajaCuenta(id) {
    axios.patch(`${URL_CUENTAS_EMPRESAS}/${id}`, { is_active: "No" }, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    }).then(() => {
      Swal.fire("¡Listo!", "Cuenta desactivada", "success");
      setCuentas(cuentas.map((i) => { if (id === i._id) i.is_active = "No"; return i; }));
    }).catch(() => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" }));
  }

  return (
    <>
      <Header />
      {user.menu_empresas ? (
        <div className="card container col-sm-11">

          {/* ── Page header ──────────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcBuilding style={{ marginRight: 8, color: "#3b82f6" }} />
                Empresas
              </h3>
              <p className="page-subtitle">Catálogo de empresas y datos fiscales</p>
            </div>
            <div className="page-actions">
              <Button color="success" size="sm" onClick={toggleCreate}>
                <IcPlus style={{ marginRight: 6 }} />
                Nueva Empresa
              </Button>
            </div>
          </div>

          {/* ── Tabla ────────────────────────────────────────────────────── */}
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Prefijo</th>
                <th>Razón Social</th>
                <th>RFC</th>
                <th>Régimen Fiscal</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {empresas
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => (
                  <tr key={a._id}>
                    <td>{a.name}</td>
                    <td>{a.prefijo}</td>
                    <td>{a.razonSocial}</td>
                    <td>{a.rfc}</td>
                    <td>{a.regimenFiscal}</td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <Button color="info" size="sm" title="Editar"
                          onClick={() => jalaInfo(a._id, a.name, a.prefijo, a.razonSocial, a.rfc, a.cp, a.regimenFiscal, a.direccionFiscal)}>
                          <IcEdit />
                        </Button>
                        <Button color="primary" size="sm" title="Cuentas bancarias"
                          onClick={() => cue(a._id, a.razonSocial)}>
                          <IcDollar />
                        </Button>
                        <Baja
                          idStatus={a._id}
                          is_active={a.is_active}
                          URL_BAJA={process.env.REACT_APP_URL_EMPRESAS}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      {/* ── Modal: Nueva Empresa ──────────────────────────────────────────── */}
      <Modal size="md" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcPlus style={{ marginRight: 8, color: "#10b981" }} />
          Nueva Empresa
        </ModalHeader>
        <ModalBody>
          <Label>Nombre</Label>
          <Input type="text" placeholder="Nombre de la empresa" value={cName} required
            onChange={(e) => setCName(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Prefijo</Label>
          <Input type="text" placeholder="Prefijo" value={cPrefijo} required
            onChange={(e) => setCPrefijo(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Razón Social</Label>
          <Input type="text" placeholder="Razón Social" value={cRazonSocial} required
            onChange={(e) => setCRazonSocial(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>RFC</Label>
          <Input type="text" placeholder="RFC" value={cRfc} required
            onChange={(e) => setCRfc(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Régimen Fiscal</Label>
          <Input type="select" value={cRegimenFiscal} required
            onChange={(e) => setCRegimenFiscal(e.target.value)} style={{ marginBottom: 10 }}>
            {REGIMEN_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </Input>
          <Label>Dirección Fiscal</Label>
          <Input type="text" placeholder="Dirección Fiscal" value={cDireccionFiscal} required
            onChange={(e) => setCDireccionFiscal(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>CP</Label>
          <Input type="text" placeholder="Código Postal" value={cCp} required
            onChange={(e) => setCCp(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveEmpresas} disabled={!validaBoton}>Guardar</Button>
          <Button color="secondary" onClick={toggleCreate}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal: Editar Empresa ─────────────────────────────────────────── */}
      <Modal size="md" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <IcEdit style={{ marginRight: 8, color: "#3b82f6" }} />
          Editar Empresa
        </ModalHeader>
        <ModalBody>
          <Label>Nombre</Label>
          <Input type="text" value={name} required
            onChange={(e) => setName(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Prefijo</Label>
          <Input type="text" placeholder="Prefijo" value={prefijo} required
            onChange={(e) => setPrefijo(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Razón Social</Label>
          <Input type="text" placeholder="Razón Social" value={razonSocial} required
            onChange={(e) => setRazonSocial(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>RFC</Label>
          <Input type="text" placeholder="RFC" value={rfc} required
            onChange={(e) => setRfc(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Régimen Fiscal</Label>
          <Input type="select" value={regimenFiscal} required
            onChange={(e) => setRegimenFiscal(e.target.value)} style={{ marginBottom: 10 }}>
            {REGIMEN_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </Input>
          <Label>Dirección Fiscal</Label>
          <Input type="text" placeholder="Dirección Fiscal" value={direccionFiscal} required
            onChange={(e) => setDireccionFiscal(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>CP</Label>
          <Input type="text" placeholder="CP" value={cp} required
            onChange={(e) => setCP(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editEmpresa}>Guardar</Button>
          <Button color="secondary" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal: Cuentas Bancarias ──────────────────────────────────────── */}
      <Modal size="xl" isOpen={modalCuenta} toggle={toggleCuenta}>
        <ModalHeader toggle={toggleCuenta}>
          <IcUniversity style={{ marginRight: 8, color: "#3b82f6" }} />
          Cuentas — {razonSocialCuenta}
        </ModalHeader>
        <ModalBody>
          <Table striped borderless className="table-dark-header">
            <thead>
              <tr>
                <th>Banco</th>
                <th>RFC</th>
                <th>Cuenta</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {cuentas.map((a) => (
                <tr key={a._id}>
                  <td>
                    <Input type="text" name="banco" value={a.banco}
                      onChange={(e) => handleChangeInputCuentasExistentes(a._id, e)} />
                  </td>
                  <td>
                    <Input type="text" name="rfc" value={a.rfc}
                      onChange={(e) => handleChangeInputCuentasExistentes(a._id, e)} />
                  </td>
                  <td>
                    <Input name="cuenta" type="text" value={a.cuenta} required
                      onChange={(e) => handleChangeInputCuentasExistentes(a._id, e)} />
                  </td>
                  <td>
                    {a.is_active === "Si" ? (
                      <Button size="sm" color="danger" onClick={() => bajaCuenta(a._id)} tabIndex="-1">
                        <IcXCircle />
                      </Button>
                    ) : (
                      <Button size="sm" color="primary" onClick={() => altaCuenta(a._id)} tabIndex="-1">
                        <IcCheckCircle />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
              {inputFieldsCuentas.map((a) => (
                <tr key={a.id}>
                  <td>
                    <Input type="text" name="banco" value={a.banco}
                      onChange={(e) => handleChangeInputCuentas(a.id, e)} />
                  </td>
                  <td>
                    <Input type="text" name="rfc" value={a.rfc}
                      onChange={(e) => handleChangeInputCuentas(a.id, e)} />
                  </td>
                  <td>
                    <Input name="cuenta" type="text" value={a.cuenta} required
                      onChange={(e) => handleChangeInputCuentas(a.id, e)} />
                  </td>
                  <td>
                    <div style={{ display: "flex", gap: 4 }}>
                      <Button size="sm" color="danger" onClick={() => handleRemoveFieldsCuentas(a.id)} tabIndex="-1">
                        <IcMinus />
                      </Button>
                      <Button size="sm" color="info" onClick={handleAddFieldsCuentas} tabIndex="-1">
                        <IcPlus />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveCuenta}>Guardar Cuentas</Button>
          <Button color="secondary" onClick={toggleCuenta}>Cerrar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoEmpresas;
